// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paid-membership-plan-note .description-wrapper[data-v-0741c446]{background-color:#f4f5f5;display:flex;justify-content:center;align-items:center;padding:40px 25px}.paid-membership-plan-note .description-wrapper .navigation-to-plan-selection[data-v-0741c446]{max-width:750px;width:100%}", ""]);
// Exports
module.exports = exports;
